'use client';

import { c as _c } from "react/compiler-runtime";
import { useHideFooter } from '@/components/footer/hide-footer-context';
import React, { type ReactNode } from 'react';

/**
 * Client wrapper for the footer that conditionally hides it based on context.
 */
export const FooterClientWrapper: React.FC<{
  children: ReactNode;
}> = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    hideFooter
  } = useHideFooter();
  if (hideFooter) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== children) {
    t1 = <>{children}</>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};